/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockInboundDetailExportDto
 */
export interface StockInboundDetailExportDto {
    /**
     * 
     * @type {string}
     * @memberof StockInboundDetailExportDto
     */
    skuId?: string;
    /**
     * 
     * @type {string}
     * @memberof StockInboundDetailExportDto
     */
    spuId?: string;
    /**
     * 
     * @type {string}
     * @memberof StockInboundDetailExportDto
     */
    orderCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StockInboundDetailExportDto
     */
    enableTime?: string;
    /**
     * 
     * @type {string}
     * @memberof StockInboundDetailExportDto
     */
    marketBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof StockInboundDetailExportDto
     */
    marketProNm?: string;
    /**
     * 
     * @type {string}
     * @memberof StockInboundDetailExportDto
     */
    marketOptionNm?: string;
    /**
     * 
     * @type {number}
     * @memberof StockInboundDetailExportDto
     */
    skuNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof StockInboundDetailExportDto
     */
    packageSpecification?: string;
    /**
     * 
     * @type {number}
     * @memberof StockInboundDetailExportDto
     */
    cbm?: number;
    /**
     * 
     * @type {number}
     * @memberof StockInboundDetailExportDto
     */
    wtKg?: number;
}

/**
 * Check if a given object implements the StockInboundDetailExportDto interface.
 */
export function instanceOfStockInboundDetailExportDto(value: object): value is StockInboundDetailExportDto {
    return true;
}

export function StockInboundDetailExportDtoFromJSON(json: any): StockInboundDetailExportDto {
    return StockInboundDetailExportDtoFromJSONTyped(json, false);
}

export function StockInboundDetailExportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockInboundDetailExportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'spuId': json['spuId'] == null ? undefined : json['spuId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'enableTime': json['enableTime'] == null ? undefined : json['enableTime'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionNm': json['marketOptionNm'] == null ? undefined : json['marketOptionNm'],
        'skuNumber': json['skuNumber'] == null ? undefined : json['skuNumber'],
        'packageSpecification': json['packageSpecification'] == null ? undefined : json['packageSpecification'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
    };
}

export function StockInboundDetailExportDtoToJSON(json: any): StockInboundDetailExportDto {
    return StockInboundDetailExportDtoToJSONTyped(json, false);
}

export function StockInboundDetailExportDtoToJSONTyped(value?: StockInboundDetailExportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'spuId': value['spuId'],
        'orderCode': value['orderCode'],
        'enableTime': value['enableTime'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionNm': value['marketOptionNm'],
        'skuNumber': value['skuNumber'],
        'packageSpecification': value['packageSpecification'],
        'cbm': value['cbm'],
        'wtKg': value['wtKg'],
    };
}

